import { render, staticRenderFns } from "./DigitalAgreementList.vue?vue&type=template&id=77766f22"
import script from "./DigitalAgreementList.vue?vue&type=script&lang=js"
export * from "./DigitalAgreementList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports